import { Box } from 'components'

const OnboardingAssignments = () => {
 return (<Box>OnboardingAssignments</Box>)
}

export default OnboardingAssignments;
